import { render } from "./AffectationList.vue?vue&type=template&id=750140a6&scoped=true"
import script from "./AffectationList.vue?vue&type=script&lang=js"
export * from "./AffectationList.vue?vue&type=script&lang=js"

import "./AffectationList.vue?vue&type=style&index=0&id=750140a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-750140a6"]])

export default __exports__